import type { Dict } from "../en";

export const common: Dict["common"] = {
  cancel: "Hủy",
  retry: "Thử lại",
  undo: "Hoàn tác",
  delete: "Xóa",
  save: "Lưu",
  close: "Đóng",
  done: "Xong",
  edit: "Sửa",
  back: "Quay lại",
  more: "Thêm",
  moreActions: "Thao tác khác",
  copy: "Sao chép",
  copied: "Đã sao chép",
  couldntCopy: "Không sao chép được",
  loading: "Đang tải…",
  loadingWhat: "Đang tải {what}…",
  couldntLoad: "Không tải được {what}.",
  keepEditing: "Tiếp tục sửa",
  discard: "Bỏ thay đổi",
  discardTitle: "Bỏ các thay đổi?",
  discardBody: "Bạn đã thay đổi một số thứ ở đây mà chưa lưu.",
  offline: "Không kết nối được với Vantage. Hãy kiểm tra kết nối mạng.",
  somethingWrong: "Đã có lỗi xảy ra.",
  didntGoThrough: "Thao tác chưa thực hiện được.",
  you: "Bạn",
  vantage: "Vantage",
};
